#import "../fragments/email-sync-status-banner-fragment.graphql"

query GetEmailSyncStatusBanner {
    emailBannerStats {
        ...EmailSyncStatusBanner
    }
}
